require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-kate-gulliver.json") })
        }
      }, "path---people-kate-gulliver");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-kate-gulliver!./.cache/json/people-kate-gulliver.json
// module id = 1461
// module chunks = 231608221292675